import { render, staticRenderFns } from "./AiVoiceRealtimeTranslate.vue?vue&type=template&id=8c4e7458&scoped=true"
import script from "./AiVoiceRealtimeTranslate.vue?vue&type=script&lang=js"
export * from "./AiVoiceRealtimeTranslate.vue?vue&type=script&lang=js"
import style0 from "./AiVoiceRealtimeTranslate.vue?vue&type=style&index=0&id=8c4e7458&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c4e7458",
  null
  
)

export default component.exports